import { css } from '@emotion/react';

import type { CountdownState } from '@/hooks/use-countdown';
import { darkTheme } from '@/theme/dark-theme';
import { mq, spacing } from '@/theme/tokens';

export interface CountdownOverlayProps {
  state: CountdownState;
  count: number | null;
  onSkip: () => void;
}

export function CountdownOverlay({ state, count, onSkip }: CountdownOverlayProps) {
  if (state === 'idle') return null;

  return (
    <div
      css={css`
        position: fixed;
        inset: 0;
        z-index: 40;
        background: ${darkTheme.overlay};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      `}
    >
      <div
        role="status"
        aria-live="assertive"
        css={css`
          font-size: 80px;
          font-weight: bold;

          ${mq.sm} {
            font-size: 120px;
          }
          color: ${darkTheme.text};
          user-select: none;
        `}
      >
        {count}
      </div>
      <button
        type="button"
        onClick={onSkip}
        aria-label="Skip countdown"
        css={css`
          position: absolute;
          bottom: ${spacing.xxl};
          background: ${darkTheme.surface};
          color: ${darkTheme.text};
          border: 1px solid ${darkTheme.border};
          min-height: 44px;
          padding: 12px ${spacing.lg};
          border-radius: 6px;
          cursor: pointer;
          font-size: 16px;

          &:hover {
            background: ${darkTheme.border};
          }
        `}
      >
        Skip
      </button>
    </div>
  );
}
